export default "__VITE_ASSET__DqCQaoQ0__"